import React from 'react';
import { motion } from 'framer-motion';
export function Objection() {
  return <section className="w-full bg-white py-20 md:py-32 px-4" data-id="element-64">
      <div className="max-w-4xl mx-auto text-center" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-66">
          <p className="text-3xl md:text-5xl font-black mb-6" data-id="element-67">
            No necesitás más información.
          </p>

          <p className="text-3xl md:text-5xl font-black mb-6" data-id="element-68">
            Necesitás <span className="bg-yellow-400 px-2" data-id="element-69">empezar</span>.
          </p>

          <p className="text-2xl md:text-4xl font-bold text-gray-700" data-id="element-70">
            Podés seguir igual… o cambiar en 21 días.
          </p>
        </motion.div>
      </div>
    </section>;
}